import {useHubLazyLoadProvider} from 'components/hubList/providers/HubLazyLoadProvider';
import {useHubSearchlLazyLoadProvider} from 'components/hubList/providers/HubSearchLazyLoadProvider';
import {IHubConfig, IHubConfigSearch} from 'models/hubConfigs';

export const useHubTableList = (
  isSearchActive: boolean,
): {
  items: IHubConfig[] | undefined;
  lazyLoad: () => void;
  isLazyLoading: boolean;
  isLoading: boolean;
  isError: boolean;
  search: (params: IHubConfigSearch) => void;
  searchParams: IHubConfigSearch | undefined;
  totalCount: number;
  error;
} => {
  const {items, lazyLoad, isLazyLoading, isError, isLoading, search, totalCount, error} = useHubLazyLoadProvider();
  const {
    items: searchItems,
    lazyLoad: searchLazyLoad,
    isLoading: isSearchLoading,
    isLazyLoading: isSearchLazyLoading,
    isError: isSearchError,
    search: searchSearch,
    searchParams,
    totalCount: searchTotalCount,
    error: searchError,
  } = useHubSearchlLazyLoadProvider();

  return {
    items: isSearchActive ? searchItems : items,
    isLoading: isSearchActive ? isSearchLoading : isLoading,
    lazyLoad: isSearchActive ? searchLazyLoad : lazyLoad,
    isLazyLoading: isSearchActive ? isSearchLazyLoading : isLazyLoading,
    isError: isSearchActive ? isSearchError : isError,
    search: isSearchActive ? searchSearch : search,
    searchParams: isSearchActive ? searchParams : undefined,
    totalCount: isSearchActive ? searchTotalCount : totalCount,
    error: isSearchActive ? searchError : error,
  };
};
